import { DefaultTheme, css, useTheme } from 'styled-components';

import { commonPalette } from './commonPalette';
import { lightTheme } from './lightTheme';
import { darkTheme } from './darkTheme';

export type Breakpoints = 'tablet' | 'desktop';

export const breakpoints: Record<Breakpoints, number> = {
  tablet: 768,
  desktop: 1024,
};

export const getTheme = (type?: string): DefaultTheme => {
  let theme;
  switch (type) {
    case 'dark':
      theme = darkTheme;
      break;
    default:
      theme = lightTheme;
      break;
  }

  return {
    ...theme,
    common: commonPalette,
  };
};

type FocusOutlineProps = {
  color?: string;
  excludeSelector?: boolean;
};

export const focusOutline = ({
  color,
  excludeSelector = false,
}: FocusOutlineProps): ReturnType<typeof css> => {
  const outlineCss = css`
    ${({ theme }: { theme: DefaultTheme }) => `
    outline: ${color || theme.palette.system.info.focus} solid 2px;
    outline-offset: 3px;
  `}
  `;

  // use this where applying css to a component that is not the actual focus component
  // e.g. the border of an input
  if (excludeSelector) {
    return outlineCss;
  }

  return css`
    &:focus {
      ${outlineCss}
    }
  `;
};

export const useMyTheme = (): DefaultTheme => {
  return useTheme();
};

export const hocus = (): string => {
  return '&:hover, &:focus';
};
